var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 255.1",
    style: {
      enableBackground: "new 0 0 255.1 255.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4CD1C0;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 127.6,
    cy: 127.6,
    r: 121.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.008,106.491 123.443,127.624 80.008,148.709 36.572,127.629  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.192,106.491 131.757,127.624 175.192,148.709 218.628,127.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.192,52.127 131.757,74.989 131.757,119.755 132.087,119.591 132.087,119.591 132.704,119.284  175.18,98.148 175.179,98.147 175.192,98.141  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.192,203.073 131.757,180.211 131.757,135.445 132.087,135.609 132.087,135.609 132.704,135.916  175.18,157.052 175.179,157.053 175.192,157.059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.008,52.127 123.443,74.989 123.443,119.755 123.113,119.591 123.113,119.591 122.496,119.284  80.02,98.148 80.021,98.147 80.008,98.141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.008,203.073 123.443,180.211 123.443,135.445 123.113,135.609 123.113,135.609 122.496,135.916  80.02,157.052 80.021,157.053 80.008,157.059  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.a2369f6d8a91bdaa0127ea83dd561c42.svg";
export { ForwardRef as ReactComponent };